import { KTSVG } from '@helpers/index';
import { FormattedMessage } from 'react-intl';
import { LoginWrapper } from './LoginWrapper';
import { useNavigate } from 'react-router-dom';
import { Button } from '@components/index';
import { useDispatch, useSelector } from 'react-redux';
import { authLogout } from '../core/actions';
import { getAuthTokenSelector } from '../core/selectors';
import { useQuery } from '@shared/index';

export const ReLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getQueryParam } = useQuery();

  const logoLink = window.location.host.includes('.de')
    ? 'https://hellobello.de'
    : 'https://hellobello.at';

  const sessionToken = getQueryParam('sessionToken');

  const accessToken = useSelector(getAuthTokenSelector);

  const relogin = () => {
    if (accessToken) dispatch(authLogout({ accessToken }));
    navigate(`/auth?sessionToken=${sessionToken}`);
  };

  const continueSession = () => navigate('/');

  return (
    <LoginWrapper>
      <div className="login-logo">
        <a
          href={logoLink}
          target="_blank"
          className="w-[8rem] block mx-auto"
          rel="noopener noreferrer">
          <KTSVG path="/media/logos/logo-green.svg" className="w-full h-auto" />
        </a>
      </div>
      <h1>
        <span className="login-headline">
          <FormattedMessage id="AUTH.RELOGIN.HEADLINE" />
        </span>
        <span className="login-headline-sup">
          <FormattedMessage id="AUTH.RELOGIN.HEADLINE_SUP" />
        </span>
      </h1>

      <p className="login-text">
        <FormattedMessage id="AUTH.RELOGIN.TEXT" />
      </p>

      <a href="mailto:support@hellobello.at" className="text-center text-light-600">
        <FormattedMessage id="AUTH.RELOGIN.SUPPORT" />
      </a>

      <div className="flex flex-col gap-3 mt-12">
        <Button onClick={relogin} variant="outline">
          <FormattedMessage id="AUTH.RELOGIN.AGAIN" />
        </Button>
        <Button onClick={continueSession}>
          <FormattedMessage id="AUTH.RELOGIN.CONTINUE" />
        </Button>
      </div>
    </LoginWrapper>
  );
};
